import { MUTATION_RESPONSE_RECEIVED } from '@web-platform/shared-universal-constants/src/network';
import { RADAR_CREATE_SESSIONS } from '@web-platform/shared-universal-types/src/network/requestTypes';
import { combineReducers } from 'redux';

import { RESULTS_VIEW_SWITCH_INITIATED } from '../../actions/combinedExplore';

import cityDrawer, * as fromCityDrawer from './cityDrawer';
import placeResults, * as fromPlaceResults from './placeResults';

import type { Action } from '@web-platform/shared-universal-types/src/redux/banana/actions/actions-banana-types';
import type { State } from '@web-platform/shared-universal-types/src/redux/banana/state/state-banana-types';

const isSwitchingResultsViewPoC = (state = false, action: Action): boolean => {
  switch (action.type) {
    case RESULTS_VIEW_SWITCH_INITIATED:
      return true;
    case MUTATION_RESPONSE_RECEIVED:
      return action.payload.type === RADAR_CREATE_SESSIONS ? false : state;
    default:
      return state;
  }
};

export default combineReducers({
  placeResults,
  cityDrawer,
  isSwitchingResultsViewPoC,
});

export const getPlaceResultsState = (state: State) =>
  fromPlaceResults.get(state.combinedExplore.placeResults);

export const getCityDrawerState = (state: State) =>
  fromCityDrawer.get(state.combinedExplore.cityDrawer);

export const getIsSwitchingResultsViewPoC = (state: State): boolean =>
  state.combinedExplore.isSwitchingResultsViewPoC;
